module.exports = __webpack_public_path__ + "img/box.ad771bf6.png";